import { createFileRoute } from "@tanstack/react-router";
import { serviceSchemaScripts } from "@/lib/service-schema";
import CreacionWebReact from "@/pages/servicios/CreacionWebReact";


export const Route = createFileRoute("/servicios/creacion-web-react")({
  head: () => ({
    meta: [
      { title: "Desarrollo Web React | Tu Web Debería Vender, No Solo Existir | SEOEVOLUTION" },
      { name: "description", content: "Tu web debería ser tu mejor comercial. Desarrollo React + IA: 10x más rápida que WordPress, diseño único, SEO perfecto. Si tu web no convierte, estás perdiendo dinero cada día." },
      { name: "keywords", content: "desarrollo web React, páginas web rápidas, diseño web personalizado, SEO React, desarrollo web IA, páginas web optimizadas" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/servicios/creacion-web-react" },
      { property: "og:title", content: "Tu Web Debería Vender, No Solo Existir | SEOEVOLUTION" },
      { property: "og:description", content: "Desarrollo web React + IA: máxima velocidad, diseño personalizado, UX perfecto y mejor SEO del mercado. Si tu web no convierte, te está costando dinero." },
      { name: "twitter:title", content: "Tu Web Debería Vender, No Solo Existir | SEOEVOLUTION" },
      { name: "twitter:description", content: "Desarrollo web React + IA: máxima velocidad, diseño personalizado, UX perfecto y mejor SEO del mercado." },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/servicios/creacion-web-react" }],
    scripts: serviceSchemaScripts("creacion-web-react"),
  }),
  component: CreacionWebReact,
});
